<template>
	<div>
		<b-collapse v-model="showModal">
			<div class="body">
				<div id="hideinmobile" class="dashed-div"></div>
				<div
					:class="[
						(!loadingData && assessmentSuggestions.length == 0) ||
						$route.name === 'interviewskills'
							? ''
							: 'scrollable-list',
					]"
					ref="scrollContainer"
					@scroll="onAssessmentScroll"
				>
					<div v-if="loadingData">
						<div v-for="i in 10" :key="i" class="d-flex asmnt-card mb-2">
							<div class="asp-top-card">
								<div>
									<img
										src="../../assets/newdesign/assessPro/assDP.svg"
										alt=""
									/>
								</div>

								<div class="pl-2 width-93">
									<div
										class="d-flex align-items-center justify-content-between"
									>
										<div class="asp-card-head-txt text-truncate w-75">
											<b-skeleton class="w-75 h-15"></b-skeleton>
										</div>
									</div>

									<div class="d-flex align-items-center mob-flex-column mt-1">
										<span class="asp-grey-txt-light">Topic Name :</span>

										<div class="asp-grey-txt text-truncate w65 ml-2 mob-ml-2">
											<b-skeleton class="w-75 h-15"></b-skeleton>
										</div>
									</div>
								</div>
							</div>

							<div class="inki-dflex">
								<div class="d-flex justify-content-end">
									<div
										class="d-flex align-items-center mb-descriptn-txt-1 mob-fs-10"
									>
										<img
											class="mr-1"
											src="../../assets/newdesign/assessPro/sandClock.svg"
											alt=""
										/>
										<b-skeleton class="w-100 h-15"></b-skeleton>
										<span>Min(s)</span>
									</div>

									<div class="asp-vertical-line ml-2 mr-2"></div>

									<div class="d-flex align-items-center">
										<img
											class="mr-2"
											src="../../assets/newdesign/assessPro/level.svg"
											alt=""
										/>
										<div class="d-flex align-items-center">
											<span class="mb-descriptn-txt-1 mob-fs-10 mr-1"
												>Level :</span
											>
											<span class="mb-mobile-txt mob-fs-10">
												<b-skeleton class="w-100 h-15"></b-skeleton>
											</span>
										</div>
									</div>
								</div>

								<div class="d-flex align-items-center mt-2">
									<div
										class="d-flex align-items-center mob-fs-12 asp-blue-txt pointer ml-auto"
									>
										<b-skeleton class="w-100 h-15"></b-skeleton>
										<img
											class="ml-2"
											src="../../assets/newdesign/assessPro/viewMark.svg"
											alt=""
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div
						v-else-if="!loadingData && assessmentSuggestions.length == 0"
						class="d-flex flex-column align-items-center justify-content-center no-assessment"
					>
						<img
							src="../../assets/img/prepInterview/no-assessment.svg"
							alt=""
						/>
						<p class="fs-18 fam-lato fw-R text-666666 mt-2 text-center">
							No Assessment Found
						</p>
					</div>

					<div v-else>
						<div
							v-for="(assessment, index) in assessmentSuggestions"
							:key="index"
							class="d-flex asmnt-card mb-2"
						>
							<div class="asp-top-card">
								<div>
									<img
										src="../../assets/newdesign/assessPro/assDP.svg"
										alt=""
									/>
								</div>

								<div class="pl-2 width-93">
									<div
										class="d-flex align-items-center justify-content-between"
									>
										<div class="asp-card-head-txt text-truncate w-75">
											<span class="text-capitalize">{{
												assessment.testName
											}}</span>
										</div>
									</div>

									<div class="d-flex align-items-center mob-flex-column mt-1">
										<span class="asp-grey-txt-light">Topic Name :</span>

										<div class="asp-grey-txt text-truncate w65 ml-2 mob-ml-2">
											<span>{{ assessment.topicName }}</span>
										</div>
									</div>
								</div>
							</div>

							<div class="inki-dflex">
								<div class="d-flex justify-content-end">
									<div
										class="d-flex align-items-center mb-descriptn-txt-1 mob-fs-10"
									>
										<img
											class="mr-1"
											src="../../assets/newdesign/assessPro/sandClock.svg"
											alt=""
										/>
										<span>{{ assessment.testDuration }} Min(s)</span>
									</div>

									<div class="asp-vertical-line ml-2 mr-2"></div>

									<div class="d-flex align-items-center">
										<img
											class="mr-2"
											src="../../assets/newdesign/assessPro/level.svg"
											alt=""
										/>
										<div class="d-flex align-items-center">
											<span class="mb-descriptn-txt-1 mob-fs-10 mr-1"
												>Level :</span
											>
											<span class="mb-mobile-txt mob-fs-10">
												<span>{{ assessment.intDifficulty }}</span>
											</span>
										</div>
									</div>
								</div>

								<div class="d-flex align-items-center mt-2">
									<div
										class="asp-completed-tag mr-2"
										v-if="
											assessment.maxnoattempts == assessment.noOfAttemptsTaken
										"
									>
										Completed
									</div>

									<div
										class="d-flex align-items-end mob-fs-12 asp-blue-txt pointer ml-auto"
									>
										<span @click="routeToTakeTest(assessment)">{{
											assessment.attemptsLeft > 0
												? assessment.noOfAttemptsTaken == 0
													? "Take Test"
													: "Retake Test"
												: "View Marks"
										}}</span>
										<img
											v-if="assessment.noOfAttemptsTaken > 0"
											@click="routeToTakeTest(assessment, true)"
											class="ml-2"
											src="../../assets/newdesign/assessPro/viewMark.svg"
											alt=""
										/>
									</div>
								</div>
							</div>
						</div>
						<div>
							<div v-if="loadingMore" class="d-flex justify-content-center">
								<b-spinner label="Loading..."></b-spinner>
							</div>
						</div>
					</div>
				</div>
			</div>
			<TestDetailsAP
				v-if="showTestDetail"
				:selectedAssessment="selectedAssessment"
				:showTestDetails="showTestDetail"
				@closeTestModal="showTestDetail = false"
				@purchase-success="handlePurchaseSuccess"
				ref="testDetails"
			/>
			<AssessmentMarksModal
				v-if="showMarks"
				:showMarks="showMarks"
				:selectedAssessment="selectedAssessmentMarks"
				:isPublic="isPublic"
				@closeModal="showMarks = false"
				@take-next-attempt="takeNextAttempt"
			/>
		</b-collapse>
		<div style="display: none" ref="responseContainer"></div>
	</div>
</template>

<script>
import TestDetailsAP from "../../views/AssessmentProgress/TestDetailsAP.vue";
import AssessmentMarksModal from "@/views/AssessmentProgress/AssessmentMarksModal.vue";
import { getMarks } from "@/utils/apiFunctions";
import payment from "@/components/mixin/payment";
import { mapGetters } from "vuex";
export default {
	name: "AssessmentList",
	props: {
		showAssessments: { type: Boolean, required: true },
		assessmentSuggestions: { type: Array, required: true },
		loadingData: { type: Boolean, required: false },
		loadingMore: { type: Boolean, required: false },
		email: { type: String, required: false },
		pageStart: { type: Number, required: false },
		pageEnd: { type: Number, required: false },
		pageTotal: { type: Number, required: false },
	},
	created() {
		this.showModal = this.showAssessments;
	},
	mixins: [payment],
	watch: {
		showAssessments(val) {
			this.showModal = val;
		},
	},
	components: {
		TestDetailsAP,
		AssessmentMarksModal,
	},
	data() {
		return {
			showModal: false,
			selectedAssessment: [],
			selectedAssessmentMarks: [],
			showTestDetail: false,
			isPublic: false,
			showMarks: false,
		};
	},
	computed: {
		...mapGetters("userVUEX", {
			userInfo: "getUserInfo",
		}),
	},
	methods: {
		handlePurchaseSuccess() {
			this.assessment.purchased = true;
		},
		takeNextAttempt() {
			this.showMarks = false;
			this.showTestDetail = true;
		},
		async routeToTakeTest(assessment, viewMark = false) {
			const mobile = window.innerWidth <= 1028;
			this.isPublic = assessment.isPublic;
			this.selectedAssessment = assessment;

			const goToMobile = (name, payload) => {
				this.$store.commit("candidateVUEX/addSelectAssess", payload);
				this.$router.push({ name, query: { public: true } });
			};

			if (assessment.attemptsLeft > 0 && !viewMark) {
				if (mobile) {
					goToMobile("mobAssessment", assessment);
				} else {
					this.showTestDetail = true;
				}
				return;
			}

			const res = await getMarks({
				emailID: this.email,
				testID: assessment.testID,
				groupID: assessment.groupID,
			});

			if (res.status !== 200) return;

			this.selectedAssessmentMarks = res.data.data;

			if (mobile) {
				goToMobile("mobViewMarks", this.selectedAssessmentMarks);
			} else {
				this.showMarks = true;
			}
		},
		onAssessmentScroll(e) {
			// Check if mobile view (adjust breakpoint as needed, e.g., 1028px matches your CSS)
			const { target } = e;
			if (
				Math.ceil(target.scrollTop) >=
					target.scrollHeight - target.offsetHeight - 10 && // Added buffer
				!this.loadingMore
			) {
				if (this.checkbetween(this.pageEnd, 0, this.pageTotal)) {
					this.$emit("load-assessment");
				}
			}
		},
		checkbetween(x, min, max) {
			return x > min && x < max;
		},
	},
};
</script>
